export const getSubmoduleRelativePaths: <T extends Record<string, string>>(
  absolutePaths: T,
  submoduleTag: string,
) => T = (absolutePaths, submoduleTag) => {
  const submoduleRelativePaths: typeof absolutePaths = {} as any;

  Object.entries(absolutePaths).forEach(([key, value]) => {
    const regex = new RegExp(`^${submoduleTag}`);
    (submoduleRelativePaths as Record<string, string>)[key] = value.replace(
      regex,
      '',
    );
  });

  return submoduleRelativePaths;
};
